import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  createUnitModalTitle: {
    id: 'course-authoring.library-authoring.modals.create-unit.title',
    defaultMessage: 'New Unit',
    description: 'Title of the Create Unit modal',
  },
  createSubsectionModalTitle: {
    id: 'course-authoring.library-authoring.modals.create-subsection.title',
    defaultMessage: 'New Subsection',
    description: 'Title of the Create Subsection modal',
  },
  createSectionModalTitle: {
    id: 'course-authoring.library-authoring.modals.create-section.title',
    defaultMessage: 'New Section',
    description: 'Title of the Create Section modal',
  },
  createModalCancel: {
    id: 'course-authoring.library-authoring.modals.create-container.cancel',
    defaultMessage: 'Cancel',
    description: 'Label of the Cancel button of the Create container modal',
  },
  createContainerModalCreate: {
    id: 'course-authoring.library-authoring.modals.create-container.create',
    defaultMessage: 'Create',
    description: 'Label of the Create button of the Create container modal',
  },
  createUnitModalNameLabel: {
    id: 'course-authoring.library-authoring.modals.create-unit.form.name',
    defaultMessage: 'Name your unit',
    description: 'Label of the Name field of the Create Unit modal form',
  },
  createSectionModalNameLabel: {
    id: 'course-authoring.library-authoring.modals.create-section.form.name',
    defaultMessage: 'Name your section',
    description: 'Label of the Name field of the Create Section modal form',
  },
  createSubsectionModalNameLabel: {
    id: 'course-authoring.library-authoring.modals.create-subsection.form.name',
    defaultMessage: 'Name your subsection',
    description: 'Label of the Name field of the Create Subsection modal form',
  },
  createUnitModalNamePlaceholder: {
    id: 'course-authoring.library-authoring.modals.create-unit.form.name.placeholder',
    defaultMessage: 'Give a descriptive title',
    description: 'Placeholder of the Name field of the Create Unit modal form',
  },
  createSubsectionModalNamePlaceholder: {
    id: 'course-authoring.library-authoring.modals.create-subsection.form.name.placeholder',
    defaultMessage: 'Give a descriptive title',
    description: 'Placeholder of the Name field of the Create Subsection modal form',
  },
  createSectionModalNamePlaceholder: {
    id: 'course-authoring.library-authoring.modals.create-section.form.name.placeholder',
    defaultMessage: 'Give a descriptive title',
    description: 'Placeholder of the Name field of the Create Section modal form',
  },
  createUnitModalNameInvalid: {
    id: 'course-authoring.library-authoring.modals.create-unit.form.name.invalid',
    defaultMessage: 'Unit name is required',
    description: 'Message when the Name field of the Create Unit modal form is invalid',
  },
  createSectionModalNameInvalid: {
    id: 'course-authoring.library-authoring.modals.create-section.form.name.invalid',
    defaultMessage: 'Section name is required',
    description: 'Message when the Name field of the Create Section modal form is invalid',
  },
  createSubsectionModalNameInvalid: {
    id: 'course-authoring.library-authoring.modals.create-subsection.form.name.invalid',
    defaultMessage: 'Subsection name is required',
    description: 'Message when the Name field of the Create Subsection modal form is invalid',
  },
  createSectionSuccess: {
    id: 'course-authoring.library-authoring.modals.create-section.success',
    defaultMessage: 'Section created successfully',
    description: 'Success message when creating a library section',
  },
  createSectionError: {
    id: 'course-authoring.library-authoring.modals.create-section.error',
    defaultMessage: 'There is an error when creating the library section',
    description: 'Error message when creating a library section',
  },
  createSubsectionSuccess: {
    id: 'course-authoring.library-authoring.modals.create-subsection.success',
    defaultMessage: 'Subsection created successfully',
    description: 'Success message when creating a library subsection',
  },
  createSubsectionError: {
    id: 'course-authoring.library-authoring.modals.create-subsection.error',
    defaultMessage: 'There is an error when creating the library subsection',
    description: 'Error message when creating a library subsection',
  },
  createUnitSuccess: {
    id: 'course-authoring.library-authoring.modals.create-unit.success',
    defaultMessage: 'Unit created successfully',
    description: 'Success message when creating a library unit',
  },
  createUnitError: {
    id: 'course-authoring.library-authoring.modals.create-unit.error',
    defaultMessage: 'There is an error when creating the library unit',
    description: 'Error message when creating a library unit',
  },
});

export default messages;
